import React from "react";
import { Link } from "react-router-dom";
 
function Footer() {
    return (
        <>
            <footer className="vl-footer-area10">
                {/* footer area start */}
                <div className="footer-bottom-content">
                    <div className="container">
                        {/* FIX ADDED HERE:
                           Added 'justify-content-between' to distribute space evenly
                        */}
                        <div className="row justify-content-between">
                           
                            {/* Column 1: Logo & Info (Keep as 4) */}
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                <div className="vl-footer-widget-black6 vl-footer1-logo-area mr-50 mb-50">
                                    <div className="vl-footer-logo black-logo">
                                        <a href="index.html">
                                            <img src="/assets/img/logo/ashok-nanda-logo.png" alt="Ashok Nanda Logo" />
                                        </a>
                                    </div>
                                    <div className="vl-footer-text heading6 mt-20">
                                        <p className="mt-16" style={{ lineHeight: 1.7 }}>
                                            {/* <strong>Writing</strong><br /> */}
                                            Ashok Nanda<br />
                                            Author | Social Worker | Entrepreneur | Civil Society Leader | Mentor<br />
                                            Working towards a more humane, inclusive, productive and dignified society.
                                        </p>
                                    </div>
                                    <div className="vl-footer-social10 text-start mt-20">
                                        <a href="#"><i className="fa-brands fa-facebook-f" /></a>
                                        <a href="#"><i className="fa-brands fa-instagram" /></a>
                                        <a href="#"><i className="fa-brands fa-linkedin-in" /></a>
                                        <a href="#"><i className="fa-brands fa-x-twitter" /></a>
                                    </div>
                                </div>
                            </div>
 
                            {/* Column 2: Quick Links (Keep as 2) */}
                            {/* REMOVED 'ml-20' to let justify-content handle the spacing evenly */}
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="vl-footer-widget-black10 mb-50 md:ml-30 sm:ml-0">
                                    <h4>Quick Links</h4>
                                    <div className="vl-footer-list">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/About">About Us</Link></li>
                           
                                            <li><Link to="/Blog">Blog</Link></li>
                                            
                                           
                                        </ul>
                                    </div>
                                </div>
                            </div>
 
                            {/* Column 3: Map (Replaces Contact Information) */}
                            <div className="col-lg-3 col-md-8 col-sm-6">
                                <div className="vl-footer-widget-black6 mb-50 sm:ml-0 md:ml-0">
                                    <h4>Location</h4>
                                    <div className="vl-footer-map mt-3" style={{overflow: 'hidden', borderRadius: 6}}>
                                        <iframe
                                            title="Ashok Nanda Location"
                                            src="https://maps.google.com/maps?q=7Q6Q+4F3,+Khandagiri,+Bhubaneswar,+Odisha+751030&output=embed"
                                            style={{border:0, width: '100%', height: '220px'}}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        />
                                    </div>
                                    <div className="mt-2">
                                        <a href="https://www.google.com/maps/search/?api=1&query=7Q6Q+4F3,+Khandagiri,+Bhubaneswar,+Odisha+751030" target="_blank" rel="noreferrer">Open in Google Maps</a>
                                    </div>
                                </div>
                            </div>
 
                        </div>
                    </div>
                </div>
                {/* footer area end */}
 
                {/* copy-right area start */}
                {/* <div className="container">
                    <div className="row vl-copyright10 _dv-top align-items-center">
                        <div className="col-lg-6">
                            <div className="copyright-text left-side">
                                <p>ⓒCopyright 2025 SEOX . All rights reserved</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="copyright-text right-side text-end sm:text-start md:text-start">
                                <a href="#">Terms &amp; Conditions</a>
                                <a href="#" className="add-before">{" "}Privacy Policy{" "}</a>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* copy-right area end */}
            </footer>
        </>
    );
}
 
export default Footer;